/* ==========================================================================
   OliveDrab — collection page

   Filters, sort, the quick size row and load more all work as plain links and
   form submits with no JavaScript. This upgrades them to fetch the section
   through Shopify's section rendering API and swap the grid in place, keeping
   the URL, history and scroll position sane.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  var DENSITY_KEY = 'od_grid_density';

  function setup(root) {
    if (root.dataset.odColBound) return;
    root.dataset.odColBound = '1';

    var sectionId = root.dataset.sectionId;
    var results = $('[data-od-results]', root);
    var controller = null;

    /* --------------------------------------------------------- fetching */

    function render(url, opts) {
      opts = opts || {};
      if (!results || !sectionId) { window.location.href = url; return; }

      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      results.classList.add('is-loading');

      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);

      fetch(target.toString(), controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('Filter request failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          swap(doc, '[data-od-results]');
          swap(doc, '[data-od-chips]');
          swap(doc, '[data-od-count-label]');
          swap(doc, '#od-col-side-' + cssEscape(sectionId));
          swap(doc, '[data-od-filter-drawer] .od-col-drawer__body');

          // strip the helper param before it reaches the address bar
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          var finalUrl = clean.pathname + (clean.search || '');

          if (opts.replace) window.history.replaceState({ od: true }, '', finalUrl);
          else window.history.pushState({ od: true }, '', finalUrl);

          results.classList.remove('is-loading');
          rebind();
          applyDensity(readDensity(), false);

          if (window.OD && window.OD.refresh) window.OD.refresh(results);
          if (window.OD && window.OD.initRails) window.OD.initRails(results);

          if (opts.scroll !== false) {
            var top = root.getBoundingClientRect().top + window.pageYOffset -
                      (parseInt((window.ODConfig || {}).headerHeight, 10) || 0) - 16;
            window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
          }

          announce();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          // never leave the shopper stuck on a stale grid
          results.classList.remove('is-loading');
          window.location.href = url;
        });
    }

    function cssEscape(v) {
      if (window.CSS && CSS.escape) return CSS.escape(v);
      return String(v).replace(/[^\w-]/g, '\\$&');
    }

    function swap(doc, selector) {
      var incoming = doc.querySelector(selector);
      var existing = $(selector, root) || document.querySelector(selector);
      if (!incoming || !existing) return;
      existing.innerHTML = incoming.innerHTML;
    }

    function announce() {
      var label = $('[data-od-count-label]', root);
      if (!label) return;
      var live = document.getElementById('od-col-live');
      if (!live) {
        live = document.createElement('span');
        live.id = 'od-col-live';
        live.className = 'od-sr';
        live.setAttribute('aria-live', 'polite');
        document.body.appendChild(live);
      }
      live.textContent = label.textContent.trim() + ' found';
    }

    /* ---------------------------------------------------------- binding */

    function rebind() {
      // filter and sort links
      $$('[data-od-filter-link]', root).forEach(function (a) {
        if (a.dataset.odBound) return;
        a.dataset.odBound = '1';
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          render(a.href, { scroll: false });
        });
      });

      // facet forms submit on change
      $$('[data-od-facets]', root).forEach(function (form) {
        if (form.dataset.odBound) return;
        form.dataset.odBound = '1';

        var debounce = null;

        function submit() {
          var params = new URLSearchParams(new FormData(form));
          // drop empty values so the URL stays readable
          var cleaned = new URLSearchParams();
          params.forEach(function (v, k) {
            if (v !== '' && v != null) cleaned.append(k, v);
          });
          var base = form.getAttribute('action') || root.dataset.url;
          var qs = cleaned.toString();
          render(base + (qs ? '?' + qs : ''), { scroll: false });
        }

        form.addEventListener('change', function (e) {
          if (e.target.type === 'number') return; // handled on input, debounced
          // one size box stands for every spelling of that size
          var group = e.target.dataset && e.target.dataset.odSizeGroup;
          if (group) {
            $$('[data-od-size-twin="' + group + '"]', form).forEach(function (twin) {
              twin.checked = e.target.checked;
            });
          }
          submit();
        });

        form.addEventListener('input', function (e) {
          if (e.target.type !== 'number') return;
          clearTimeout(debounce);
          debounce = setTimeout(submit, 550);
        });

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          submit();
        });
      });

      // sort
      $$('[data-od-sort]', root).forEach(function (sel) {
        if (sel.dataset.odBound) return;
        sel.dataset.odBound = '1';
        sel.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sel.value);
          url.searchParams.delete('page');
          render(url.toString(), { scroll: false });
          // keep the hidden mirrors in the facet forms in step
          $$('[data-od-sort-mirror]', root).forEach(function (i) { i.value = sel.value; });
        });
      });

      // load more, when every piece is already in the page: reveal the next batch
      $$('[data-od-show-more]', root).forEach(function (btn) {
        if (btn.dataset.odBound) return;
        btn.dataset.odBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var grid = $('[data-od-grid]', root);
          if (!grid) return;
          var batch = parseInt(grid.dataset.odBatch, 10) || 24;
          var next = $$('[data-od-deferred]', grid).slice(0, batch);
          next.forEach(function (card) { card.removeAttribute('data-od-deferred'); });
          if (window.OD && window.OD.refresh) window.OD.refresh(grid);

          var left = $$('[data-od-deferred]', grid).length;
          var count = $('[data-od-show-count]', root);
          var note = $('[data-od-show-note]', root);
          if (count && note) count.textContent = (parseInt(note.dataset.total, 10) || 0) - left;
          if (!left) btn.hidden = true;

          if (next.length) {
            var link = next[0].querySelector('a[href]');
            if (link) { link.setAttribute('tabindex', '-1'); link.focus({ preventScroll: true }); }
          }
        });
      });

      // load more
      $$('[data-od-load-more]', root).forEach(function (btn) {
        if (btn.dataset.odBound) return;
        btn.dataset.odBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          appendPage(btn.href, btn);
        });
      });
    }

    /* -------------------------------------------------------- load more */

    function appendPage(url, btn) {
      if (!sectionId) { window.location.href = url; return; }
      var label = $('span', btn) || btn;
      var original = label.textContent;
      label.textContent = 'Loading';
      btn.setAttribute('aria-busy', 'true');

      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);

      fetch(target.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('Load more failed: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-od-grid]');
          var grid = $('[data-od-grid]', root);
          if (!incoming || !grid) throw new Error('Grid not found in response');

          var added = Array.prototype.slice.call(incoming.children);
          added.forEach(function (node) { grid.appendChild(node); });

          // replace the pagination block with whatever came back
          var pagIn = doc.querySelector('[data-od-pagination]');
          var pag = $('[data-od-pagination]', root);
          if (pag) {
            if (pagIn) pag.innerHTML = pagIn.innerHTML;
            else pag.remove();
          }

          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          window.history.replaceState({ od: true }, '', clean.pathname + (clean.search || ''));

          rebind();
          if (window.OD && window.OD.refresh) window.OD.refresh(grid);

          // move focus to the first new card so keyboard users keep their place
          if (added.length) {
            var link = added[0].querySelector('a[href]');
            if (link) {
              link.setAttribute('tabindex', '-1');
              link.focus({ preventScroll: true });
            }
          }
        })
        .catch(function () {
          label.textContent = original;
          btn.removeAttribute('aria-busy');
          window.location.href = url;
        });
    }

    /* ---------------------------------------------------------- density */

    function readDensity() {
      try { return localStorage.getItem(DENSITY_KEY) || 'm'; } catch (e) { return 'm'; }
    }

    function applyDensity(d, persist) {
      var grid = $('[data-od-grid]', root);
      if (grid) grid.setAttribute('data-density', d);
      $$('[data-od-density]', root).forEach(function (b) {
        var on = b.dataset.odDensity === d;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      if (persist) {
        try { localStorage.setItem(DENSITY_KEY, d); } catch (e) {}
      }
    }

    $$('[data-od-density]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyDensity(btn.dataset.odDensity, true);
      });
    });

    applyDensity(readDensity(), false);

    /* ----------------------------------------------------------- drawer */

    var drawer = $('[data-od-filter-drawer]', root);
    if (drawer) {
      var openers = $$('[data-od-filter-open]', root);
      var closers = $$('[data-od-filter-close]', drawer);
      var panel = $('.od-col-drawer__panel', drawer);
      var release = null;
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        if (window.OD && window.OD.lockScroll) window.OD.lockScroll();
        if (window.OD && window.OD.focusTrap) release = window.OD.focusTrap(panel, close);
        openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var first = $('button, a, input, select', panel);
        if (first) setTimeout(function () { first.focus(); }, 80);
      }

      function close() {
        drawer.classList.remove('is-open');
        if (window.OD && window.OD.unlockScroll) window.OD.unlockScroll();
        if (release) { release(); release = null; }
        openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        setTimeout(function () {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, reduced() ? 0 : 420);
      }

      openers.forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      closers.forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); close(); });
      });
    }

    /* ---------------------------------------------------------- history */

    window.addEventListener('popstate', function (e) {
      if (!e.state || !e.state.od) return;
      render(window.location.href, { replace: true, scroll: false });
    });

    rebind();
  }

  function init(ctx) {
    $$('[data-od-collection]', ctx || document).forEach(function (root) {
      try { setup(root); } catch (e) {
        if (window.console && console.warn) console.warn('[OD collection]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
